/**
 * Shared Lucide icon renderer for all Lit components.
 *
 * Usage:
 *   import { lucideIcon } from '../icon.js';
 *   import { Folder, Plus } from 'lucide';
 *
 *   html`<span>${unsafeSVG(lucideIcon(Folder, 18))}</span>`
 */
export function lucideIcon(iconData, size = 18) {
    if (!iconData) return '';
    const children = iconData
        .map(([tag, attrs]) => {
            const attrStr = Object.entries(attrs)
                .map(([k, v]) => `${k}="${v}"`)
                .join(' ');
            return `<${tag} ${attrStr}></${tag}>`;
        })
        .join('');
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${children}</svg>`;
}
